import React, { useEffect } from "react";
import { useAppDispatch } from "../../../../../common/hooks/hooks";
import { setCurrentStep } from "../../checkoutSlice";
import { useGetCartQuery } from "../../../cart/api/cartApi";
import ShippingStep from "./ShippingStep/ShippingStep";

const MiddleStep: React.FC = () => {
  const dispatch = useAppDispatch();
  const { data: cartData, isLoading } = useGetCartQuery();

  // Determine what type of middle step we need (expand this later with appointments)
  const needsShipping = cartData?.needsShipping;
  // const needsAppointment = cartData?.needsAppointment;

  const needsMiddleStep = needsShipping; // || needsAppointment

  useEffect(() => {
    if (!isLoading && cartData) {
      if (!needsMiddleStep) {
        dispatch(setCurrentStep("payment"));
      }
    }
  }, [cartData, isLoading, needsMiddleStep, dispatch]);

  if (isLoading || !cartData) return null;

  // Render the appropriate component
  if (needsShipping) {
    return <ShippingStep />;
  }

  // Future Logic:
  // if (needsAppointment) {
  //   return <AppointmentStep />;
  // }

  return null;
};

export default MiddleStep;
